import script from "./ComicNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./ComicNavbar.vue?vue&type=script&setup=true&lang=js"

import "./ComicNavbar.vue?vue&type=style&index=0&id=5d70c8ca&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d70c8ca"]])

export default __exports__